
import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { Token } from 'app/auth/dto/token.dto';
import { StorageService } from 'app/service/storage.service';
import { SeguridadUtils } from 'app/utils/seguridad-utils';
import Utils from 'app/utils/utils';

@Directive({ selector: '[hasFunction]' })
export class HasFunctionDirective {
  private token: Token;
  propiedades: any;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private storageService: StorageService,
    private seguridadUtils: SeguridadUtils) {
    this.token = JSON.parse(this.storageService.getItem('user')) as Token;
  }

  @Input() set hasFunction(funcion: string) {
    if(this.seguridadUtils.hasFunction(funcion)){
      this.viewContainer.createEmbeddedView(this.templateRef);
    }else {
      this.viewContainer.clear();
    }
  }
}